import React from 'react'
import LayoutMain from '../../components/Layout/Main/Main'
import LeftSidedImageCopyItemCollection from "../../Partials/LeftSidedImageCopyItem/collection";
import ProductMiniItemCollection from "../../Partials/ProductMiniItem/Collection";

const leftSidedImageCopyItemCollectionData = [
  {
    descriptionContent : (
      <>
        <p><strong>Think Outside gardens provides an ongoing garden maintenance service at regular intervals to provide year round piece of mind.</strong></p>

<p>On-going maintenance programs are tailored to your specific garden needs to manage pest and disease control, weed management and optimising growth.</p>

<p>Our services includes:
<ul>
	<li>Regular and ongoing maintenance visits from quarterly to monthly or weekly visits.</li>
<li>Formative pruning</li>
<li>Pest weed and disease control</li>
<li>Mulching</li>
<li>Tree pruning</li>
<li>Irrigation system check and installation</li>
<li>Pressure cleaning</li>
<li>Programmed fertilising</li>
<li>Refreshing ideas for your garden including additional planting improvements, transplanting or seasonal planting.</li>
<li>Timber deck maintenance</li>
<li>Garden lighting</li>
	</ul>
	</p>
      </>
    ),
    image : 'images/about1.jpg',
    title : 'Maintenance'
  }
]

const ProductMiniItemCollectionData = [
  {
    image : 'images/contemporary-garden-oasis.jpg',
    title : 'Consultation',
    url : '/consultation'
  },
  {
    image : 'images/contemporary-garden-oasis-4.jpg',
    title : 'Design',
    url : '/design'
  },
  {
    image : 'images/contemporary-garden-oasis.jpg',
    title : 'Estimating',
    url : '/estimating'
  },
  {
    image : 'images/contemporary-garden-oasis-2.jpg',
    title : 'Construction',
    url : '/construction'
  },
]


const PageOngoingMaintenance = () => {
  return (
    <LayoutMain>
    <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection data={leftSidedImageCopyItemCollectionData} />
        </div>
</section>
 <section className=" pt-70 pb-120 pt-sm-30 pb-sm-40">
        <div className="container-3">
            <div className="row">
            <ProductMiniItemCollection data={ProductMiniItemCollectionData} />
            </div>
            </div>
            </section>
    </LayoutMain>
  )
}

export default PageOngoingMaintenance
